import { HttpClient } from '../../../httpClient'
import { queryString } from '../../../httpClient/queryString'
import {
  OpalApiResponseDocument,
  OpalApiRequestParams,
  OpalApi,
} from '../../../schema'

type BFFPlansRequestParams = OpalApiRequestParams<'ReadPlansBFFV1'>
type BFFPlansResponse = OpalApiResponseDocument<'ReadPlansBFFV1', 200>

export function readCollection(params: BFFPlansRequestParams) {
  const url = new URL(
    `/asgard-bff/${params.path.workspace_id}/plans`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get<BFFPlansResponse>(url.toString())
    .then((res) => res.data)
}

type ExperimentalPlanRequest = OpalApi<'ExperimentalReadPlanBFFV1', 200>
type ExperimentalPlanResponse = OpalApiResponseDocument<
  'ExperimentalReadPlanBFFV1',
  200
>

export const readExperimental: ExperimentalPlanRequest = ({
  params,
}: Parameters<ExperimentalPlanRequest>[0] = {}) => {
  if (!params) {
    throw new Error(
      'readExperimental must be provided with params.path.workspace_id and params.path.plan_id'
    )
  }
  const url = new URL(
    `/asgard-bff/${params.path.workspace_id}/experimental/plans/${params.path.plan_id}`,
    window.location.origin
  )

  return HttpClient()
    .get<ExperimentalPlanResponse>(url.toString())
    .then((res) => res.data)
}
